import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ActivityLevelsEnum } from '../../../shared/constants/activity-level.constant';

@Component({
    standalone: false,
    selector: 'octo-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

    currentUser: any = null;
    currentURL = '';
    status: any = '';
    texted_logs: any = '';
    enforceUberConnectFlag: boolean = environment.ENFORCE_UBER_CONNECT_FLAG || false;
    activityLevel: any = '';
    showBreadcrumbs: boolean = true;

    // Input to know if Uber is connected
    @Input() isUberConnected$!: Observable<boolean | null>;

    /**
     * Constructor
     *
     * @param router Router: Angular Router instance 
     *
     */
    constructor(private readonly router: Router) {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((val: any) => {
                this.currentURL = val.urlAfterRedirects;
            });
    }

    /**
     * ngOnInit
     * Lifecycle hook
     */
    ngOnInit(): void {

        // Handle if isUberConnected$ is not provided
        if (!this.isUberConnected$) {
            throw new Error('BreadcrumbComponent: isUberConnected$ input is required');
        }

        this.currentUser = JSON.parse(localStorage.getItem('user') || '{}');
        this.status = localStorage.getItem('status');
        this.texted_logs = localStorage.getItem('texted_logs');
        this.activityLevel = localStorage.getItem('activity_level');
        this.showBreadcrumbs = this.activityLevel !== ActivityLevelsEnum.REAPPLY;
    }

}
